"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HandlerManager {
    constructor() {
        this.handlers = [];
    }
    addHandler(handler) {
        if (!handler) {
            throw new Error("Unable to add handler that is " + handler);
        }
        const handlerWrapper = {
            removeHandler: () => {
                this.removeHandler(handler);
            }
        };
        this.handlers.push(handler);
        return handlerWrapper;
    }
    fireEvent(event) {
        for (const handler of this.handlers) {
            event.dispatch(handler);
        }
    }
    removeHandler(handler) {
        for (let i = 0; i < this.handlers.length; i++) {
            if (this.handlers[i] === handler) {
                this.handlers.splice(i, 1);
            }
        }
    }
    hasHandlers() {
        return !!this.handlers.length;
    }
    getHandlerCount() {
        return this.handlers.length;
    }
    clear() {
        this.handlers = [];
    }
}
exports.default = HandlerManager;
//# sourceMappingURL=HandlerManager.js.map